import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { combineLatest, EMPTY, map, NEVER, Observable, distinctUntilChanged, filter, switchMap, take } from 'rxjs';

import { AppState, ConfigService } from '@fcom/core';
import { LanguageService } from '@fcom/ui-translate';
import { CmsDataService } from '@fcom/core/services';
import { CmsCollection } from '@fcom/core-api';
import { getViewedNotifications } from '@fcom/common/store';

@Component({
  selector: 'fin-cms-global-disruption-banner',
  templateUrl: './cms-global-disruption-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CmsGlobalDisruptionBannerComponent {
  private languageService = inject(LanguageService);
  private cmsDataService = inject(CmsDataService);
  private configService = inject(ConfigService);
  private store$ = inject<Store<AppState>>(Store);

  collection$: Observable<CmsCollection> = EMPTY;
  notificationNumbers$: Observable<number> = EMPTY;
  enableGlobalBanner = false;

  constructor() {
    this.enableGlobalBanner = this.configService.cfg.enableGlobalBanner;

    if (this.enableGlobalBanner) {
      this.collection$ = this.languageService.translate('fragments.globalDisturbanceBanner.url').pipe(
        filter(Boolean),
        distinctUntilChanged(),
        switchMap((url) => (url ? this.cmsDataService.getFragmentJson(url) : NEVER)),
        take(1)
      ) as Observable<CmsCollection>;

      this.notificationNumbers$ = combineLatest([
        this.store$.pipe(select(getViewedNotifications)),
        this.collection$,
      ]).pipe(
        map(
          ([viewedNotificationsIds, collection]) =>
            collection.items.filter(({ contentId }) => !viewedNotificationsIds.includes(contentId)).length
        )
      );
    }
  }
}
